/**
 * Join/leave chimes for voice rooms - rising for an arrival, falling for a
 * departure; the direction is the whole message. Voiced by lib/sounds.ts.
 */
import { playSound } from '@/lib/sounds';

export function playJoinChime(): void {
  playSound('join');
}

export function playLeaveChime(): void {
  playSound('leave');
}
